/* @flow */
/* global __PROD__ */

import analytics from './analytics';
import design from './design';

export default function* rootSaga(): Generator<*, *, *> {
  if (__PROD__) {
    yield* analytics();
  }
  yield* design();
}



// WEBPACK FOOTER //
// ./src/sagas/index.js